import angular from "angular";
import { vsComponentName, ProcessTimelineComponentOptions } from "./component";

import { vsModuleName as visTimelineModule } from "../../../../ui/vis-timeline/module";

import { vsModuleName as modelComponentSelectorModule } from "../../../../ui/modelComponentSelector";
import { StateIntervalComponentOptions } from "./detail/stateInterval";

import { vsComponentName as stateIntervalComponentName } from "./detail/stateInterval/source";

import { NoteComponentOptions } from "./detail/notes";
import { vsComponentName as notesComponentName } from "./detail/notes/source";

export const vsModuleName = "processTimelineModule";

angular
  .module(vsModuleName, [visTimelineModule, modelComponentSelectorModule])
  .component(vsComponentName, ProcessTimelineComponentOptions)
  .component(stateIntervalComponentName, StateIntervalComponentOptions)
  .component(notesComponentName, NoteComponentOptions);
